import { useState } from "react";
import { Button, IButtonProps } from "../../components/Button";
import {
  ConfirmationPopup,
  IModalProps,
} from "../../components/ConfirmationPopup";

const ConfirmButton = (props: IButtonProps) => (
  <Button {...props}>Confirm</Button>
);

export const EditValuePopup = ({
  showModal,
  setShowModal,
  value,
  editValueAction,
  cancelAction,
  fieldName,
}: {
  value: string;
  showModal: boolean;
  setShowModal: Function;
  editValueAction: (oldValue: string, newValue: string) => void;
  cancelAction: () => void;
  fieldName: string;
}) => {
  const [curValue, setCurValue] = useState<string>(value);

  return (
    <ConfirmationPopup
      confirmAction={() => editValueAction(value, curValue)}
      cancelAction={cancelAction}
      setShowModal={setShowModal}
      showModal={showModal}
      ActionButton={ConfirmButton}
    >
      <div className="w-fit flex flex-col gap-2">
        <div className="w-full text-sm font-bold">Edit {fieldName}</div>
        <input
          className="border text-base px-2 py-1"
          value={curValue}
          onChange={(e) => setCurValue(e.target.value)}
          autoFocus
        />
        <div className="text-xs w-64">
          <span className="font-bold text-warningRed">IMPORTANT : </span>When
          pressing 'Confirm', all associated Moment & Landmark nodes will be
          updated automatically.
        </div>
      </div>
    </ConfirmationPopup>
  );
};
